import API from "../../../services/api";

export const importFacebookProfile = async (profile_link, space_id, import_type) => {
  try {
    let response = await API.post("/social_imports/import_profile", {
      profile_link,
      space_id,
      import_type
    });
    return response.data;
  } catch (err) {
    let status = err.response ? err.response.status : null;
    if (status == 400) {
      let error_code = err.response.data.error_code;
      if (error_code == 29) {
        throw new Error("There is already an import request under processing.");
      } else {
        throw new Error("Invalid URL or profile contents.");
      }
    } else {
      throw new Error("Something went wrong please try later.");
    }
  }
};

export const getUserImports = async params => {
  let response = await API.get("/social_imports/get_user_imports", {
    params
  });
  return response.data;
};

export const startUpload = async (totalSize, totalChunks) => {
  return API.post("/social_imports/start_upload", {
    total_size: totalSize,
    total_parts: totalChunks
  }).then(response => response.data);
};

export const abortUpload = async uploadID => {
  return API.post("/social_imports/abort_upload", {
    upload_id: uploadID
  });
};
